import React, { useState } from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { Navigate, useParams } from 'react-router';

import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';

import { RootState } from '../../../../app/rootReducer';
import { IconLink } from '../../../../common/components/IconLink';
import { Resource } from '../../../../common/constants/resource';
import ElementLocators from '../../../../common/ElementLocators';
import { tasksResolved } from '../../../../common/helpers';
import { InvalidDrawer } from '../../../detail/drawer/InvalidDrawer';
import { PostponeDrawer } from '../../../detail/drawer/postpone/PostponeDrawer';
import { ITask } from '../../../tasks/interfaces/ITask';
import { getAllTasks } from '../../../tasks/slice/taskListSlice';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

const PostponeApplication = ({}: {}) => {
  const tasks: ITask[] = useSelector(state => getAllTasks(state.taskList));

  const copy = Resource.POSTPONE_APPLICATION_HEADER;

  // For controlling the PostponeDrawer component
  const [isOpen, setIsOpen] = useState(false);
  const isValid = tasksResolved(tasks);

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      {!isValid && (
        <InvalidDrawer isOpen={isOpen} setIsOpen={setIsOpen} labelCopy={copy} />
      )}
      {isValid && (
        <PostponeDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          applicationId={id}
        />
      )}
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faClock}
        copy={copy}
        locator={ElementLocators.POSTPONE_DECISION_LINK}
      />
    </>
  );
};

export default PostponeApplication;
